(function(root) {
  "use strict";

  const consent = root.LegitGrails.cookieConsent;
  const policy = consent.policy;
  const consentKey = "legit_consent_v1";
  const metaKey = "legit_consent_meta_v1";
  const supportedPolicyVersion = 2;

  function readCookie(name) {
    const pairs = document.cookie ? document.cookie.split(/;\s*/) : [];
    for (let index = 0; index < pairs.length; index += 1) {
      const separator = pairs[index].indexOf("=");
      if (pairs[index].slice(0, separator) === name) {
        return decodeURIComponent(pairs[index].slice(separator + 1));
      }
    }
    return null;
  }

  function isObject(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
  }

  function isValidRecord(value, meta) {
    if (!isObject(value) || !isObject(meta)) return false;
    if (value.version !== supportedPolicyVersion || value.version !== consent.config.policyVersion) return false;
    if (!policy.isRegion(value.region) || !isObject(value.categories)) return false;
    if (value.categories.necessary !== true || !policy.optionalKeys.every(function(key) {
      return typeof value.categories[key] === "boolean";
    })) return false;
    if (typeof meta.hasExplicitConsent !== "boolean" || typeof meta.needsSync !== "boolean") return false;
    if (!meta.hasExplicitConsent && meta.needsSync) return false;
    if (!(value.saleOfData === undefined || value.saleOfData === null || typeof value.saleOfData === "boolean")) return false;
    if (!(value.regionStatus === undefined || value.regionStatus === "confirmed" || value.regionStatus === "fallback")) return false;
    if (value.regionStatus === "fallback" && value.region !== "EU") return false;
    if (typeof value.source !== "string" || !value.source) return false;
    return value.updatedAt === null || (typeof value.updatedAt === "string" && isFinite(Date.parse(value.updatedAt)));
  }

  /**
   * Reads both legacy-named cookies as one strict record. Missing/string versions
   * and truthy booleans never become consent. Missing, corrupt and valid states
   * remain distinguishable for diagnostics; storage never grants defaults.
   *
   * Explicit migration: legacy policy v2 without provenance is treated as
   * confirmed, except a known technical fallback source. LOCAL legacy choices
   * cannot retrospectively prove fallback origin. No other version is migrated.
   * @returns {{status: "valid"|"missing"|"invalid", record: object|null}}
   */
  function readResult() {
    try {
      const rawConsent = readCookie(consentKey);
      const rawMeta = readCookie(metaKey);
      if (rawConsent === null && rawMeta === null) return { status: "missing", record: null };
      const value = JSON.parse(rawConsent);
      const meta = JSON.parse(rawMeta);
      if (!isValidRecord(value, meta)) return { status: "invalid", record: null };
      const record = {
        consent: Object.assign({}, value, {
          categories: policy.cloneCategories(value.categories),
          saleOfData: typeof value.saleOfData === "boolean" ? value.saleOfData : null,
          regionStatus: value.regionStatus || (value.source === "CONSERVATIVE_FALLBACK" ? "fallback" : "confirmed")
        }),
        meta: { hasExplicitConsent: meta.hasExplicitConsent, needsSync: meta.needsSync }
      };
      return { status: "valid", record: record };
    } catch (error) {
      return { status: "invalid", record: null };
    }
  }

  /** @param {ConsentState} state Only real choices or confirmed defaults may be persisted. */
  function write(state) {
    const hostname = root.location && root.location.hostname || "";
    let attributes = "; expires=" + new Date(Date.now() + 365 * 86400000).toUTCString() + "; path=/; SameSite=Lax";
    if (hostname !== "localhost" && hostname !== "127.0.0.1") attributes += "; Secure";
    if (hostname === "legitgrails.com" || /\.legitgrails\.com$/.test(hostname)) attributes += "; domain=.legitgrails.com";

    const value = {
      region: state.region,
      version: state.version,
      source: state.source,
      regionStatus: state.regionStatus,
      categories: policy.cloneCategories(state.categories),
      saleOfData: state.saleOfData,
      updatedAt: state.updatedAt
    };
    document.cookie = consentKey + "=" + encodeURIComponent(JSON.stringify(value)) + attributes;
    document.cookie = metaKey + "=" + encodeURIComponent(JSON.stringify({
      hasExplicitConsent: state.hasExplicitConsent,
      needsSync: state.needsSync
    })) + attributes;
  }

  consent.storage = {
    read: function() { return readResult().record; },
    readResult: readResult,
    write: write
  };
})(window);
